import { Box, Typography, Stack, IconButton } from "@mui/material";
import colorConfigs from "../../../configs/colorConfigs";
import { typo } from "../../../assets/fonts/font";
import CloseIcon from "@mui/icons-material/Close";

type MessageBoxProps = {
    message: string;
    showCloseIcon?: boolean;
    onClose?: () => void;
}

const MessageBox = ({
    message,
    showCloseIcon = false,
    onClose = () => {},
} : MessageBoxProps) => {
    return (
        <Stack direction="column" sx={{
            position: "relative",
            border: `2px solid ${colorConfigs.tertiary}`, 
            paddingX: 4,
            paddingY: 2,
            width: "fit-content", 
            height: "fit-content", 
            backgroundColor: colorConfigs.quaternary,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            textAlign: "center",
            }}>
            {showCloseIcon && (
                <IconButton onClick={onClose} style={{ position: "absolute", top: 4, right: 8 }}>
                    <CloseIcon sx={{fontSize: 16, color: colorConfigs.tertiary}} />
                </IconButton>
            )}
            <Typography sx={{...typo.bodyContent, lineHeight: 1.25, }}>
                {message}
            </Typography>
        </Stack>
    )
}

export default MessageBox;